export default __webpack_public_path__ + "static/8-code-monkey-86c15a15bd116bd258d466a803415f3e.png";